export const getHelioDatas = async (helio) => {
    try {
        const response = await fetch(`helio/${helio}/programme.json`, { mode: 'cors' })
        const datas = await response.json()
        return datas
    }
    catch (e) {
        return null
    }
}